export default {
    initEnvironment: () => {
        return {
            url: '/fhe/initialize',
            method: 'GET'
        };
    },
    getProductsDetails: (homeId, productType, productIdentifier) => {
        return {
            url: '/fhe/getNewProduct/:homeId/:productType/:productIdentifier',
            method: 'GET',
            route_params: {
                homeId,
                productType,
                productIdentifier
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/api.js